import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsStagesProgressWithWorks(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS,dtConfig[ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS].getReportsStagesProgressWithWorks,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}

export default {
	getReportsStagesProgressWithWorks,
}
